<template>
  <el-dialog
    :title="isEdit ? '编辑管理员' : '新增管理员'"
    :visible="visible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="管理员账号" prop="adminName">
        <el-input
          v-model="form.adminName"
          :disabled="isEdit"
          placeholder="请输入管理员账号"
        />
      </el-form-item>

      <el-form-item label="昵称" prop="nickName">
        <el-input v-model="form.nickName" placeholder="请输入昵称" />
      </el-form-item>

      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入邮箱" />
      </el-form-item>

      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号" />
      </el-form-item>

      <el-form-item v-if="!isEdit" label="密码" prop="password">
        <el-input
          v-model="form.password"
          type="password"
          placeholder="请输入密码"
          show-password
        />
      </el-form-item>

      <el-form-item label="菜单权限" prop="permissions">
        <el-checkbox-group v-model="form.permissions">
          <el-checkbox label="SYSTEM_MANAGE">管理员管理</el-checkbox>
          <el-checkbox label="USER_MANAGE">用户管理</el-checkbox>
          <el-checkbox label="GROUP_MANAGE">群组管理</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="备注">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { createAdmin, updateAdmin } from "@/api/admin";

export default {
  name: "AdminForm",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    adminData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        adminName: "",
        nickName: "",
        email: "",
        phone: "",
        password: "",
        permissions: [],
        status: 0,
        remark: "",
      },
      rules: {
        adminName: [
          { required: true, message: "请输入管理员账号", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        nickName: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        permissions: [
          {
            type: "array",
            required: true,
            message: "请选择菜单权限",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.adminData;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() {
      if (this.isEdit && this.adminData) {
        this.form = {
          ...this.adminData,
          permissions: this.adminData.permissions || [],
        };
        // 编辑时不需要密码验证
        delete this.rules.password;
      } else {
        this.form = {
          adminName: "",
          nickName: "",
          email: "",
          phone: "",
          password: "",
          permissions: [],
          status: 0,
          remark: "",
        };
        // 新增时需要密码验证
        this.rules.password = [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ];
      }

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },

    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        this.loading = true;

        if (this.isEdit) {
          this.form.id = this.adminData.id;
          await updateAdmin(this.form);
          this.$message.success("更新成功");
        } else {
          await createAdmin(this.form);
          this.$message.success("创建成功");
        }

        this.$emit("success");
      } catch (error) {
        if (error !== false) {
          // 表单验证失败时会返回 false
          console.error("提交失败:", error);
          this.$message.error("操作失败");
        }
      } finally {
        this.loading = false;
      }
    },

    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
  .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }
}
</style>
